





























































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Team } from "../../types";
import consts from "@/consts";
import Home from "@/assets/images/icons/home_tab.svg";

@Component({
  components: { Home },
})
export default class AppSidebar extends Vue {
  @Getter private teams!: Team[];
  @Getter private currentTeamID!: Number;
  @Getter private currentTeam!: Team;
  @Prop() private changeTeam!: (teamID: any) => any;

  private teamFilter: string = "";
  private lessonEditorURL: string = consts.lessonsurl;
  private created() {
    console.log(this.teams);
    console.log(this.currentTeam);
  }

  private teamColor(i: number) {
    let ith = i % 4;
    if (ith === 0) {
      return "bg-yellow-3";
    } else if (ith === 1) {
      return "bg-red-3";
    } else if (ith === 2) {
      return "bg-green-3";
    } else {
      return "bg-blue-3";
    }
  }

  get isHidden() {
    return this.$route.name === "addTeam";
  }

  get filteredTeams() {
    return this.teams.filter((team) => {
      let isCurrent = team.ID === this.currentTeamID;
      let teamName = team.Name.toLowerCase();
      return !isCurrent && teamName.indexOf(this.teamFilter.toLowerCase()) >= 0;
    });
  }
}
